<template>
    <div id="detalle">
        <div class="banner">
            <h2>AGUACATE</h2>
        </div>
        <!-- <div class="flotante">
            <img src="@/assets/images/canasta.png" alt="">
        </div> -->
        <div class="inf">
            <div class="btns">
                <div id="btn1" class="btn active" @click="cambio('origen')">ORIGEN</div>
                <div id="btn2" class="btn" @click="cambio('variedades')">VARIEDADES</div>
                <div id="btn3" class="btn" @click="cambio('dis')">DISPONIBILIDAD</div>
                <div id="btn4" class="btn" @click="cambio('prop')">PROPIEDADES</div>
                <div id="btn5" class="btn" @click="cambio('info')">INFORMACION NUTRIMENTAL</div>
            </div>
            <div id="bloques">
                <div id="origen">
                    <h2>Aguacate (Persea americana)</h2>
                    <p>El aguacate es originario de la región central y sur de América, según los estudios realizados,
                      este fruto tiene casi 9000 años de antigûedad. Los aztecas feueron quienes le dieron su nombre;
                      en la lengua náhuatl, la más común entre la cultura azteca, ahuacatl era el nombre original del ahora conocido, aguacate.

                    </p>
                </div>
                <div id="variedades">
                    <h2>Principales variedades</h2>
                    <ul>
                        <li>Hass</li>
                    </ul>
                </div>
                <div id="disponibilidad">
                    <img src="@/assets/images/Aguacate-temporada.jpg" alt="">
                </div>
                <div id="propiedades">
                    <p>Se trata de una fruta muy popular y versátil,
                      agrega sabor a prácticamente cualquier platillo y contiene grandes cantidades de vitaminas, minerales y grasas
                      mono insaturadas las cuales favorecen al metabolismo de carbohidratos, la salud de la presión arterial y evitan muchas enfermedades.
                    </p>
                    <p>
                       Un aguacate de tamaño mediano, aproximadamente de 150 g de pedo,
                       proporciona cerca de 250 calorías. Aunque estas calorías provienen de grasas mono insaturadas,
                       y ello hace del aguacat una excelente alternativa para proporcionar energia al cuerpo de manera saludable,
                       evitando las dañinas grasas saturadas y grasas trans. Una de estas grasas mono insaturadas es el ácido oleico,
                       el cual puede reducir el nivel del colesterol en el organismo. Además, a este compuesto se le han atribuido propiedades
                       para reducir el riesgo de desarrollar ciertos tipos de cáncer, por ejemplo, el cáncer de mama en la mujer.
                    </p>
                    <p>
                      La buena cantidad de potasio presente en los aguacates también reduce el riesgo de desarrollar
                      enfermedades cardiovasculares y del corazón, como la presión arterial alta y los infartos,
                      especialmente cuando en la dieta se reduce la ingesta de sodio.
                      Es sorprendente saber que un aguacate contiene tres veces más potasio que un plátano.
                    </p>
                </div>
                <div id="info-nut">
                  <img src="@/assets/images/tablaAguacate.jpg" alt="">
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
  data() {
    return {

    };
  },
  methods: {
    cambio(active) {
      const btn1 = document.getElementById('btn1');


      const btn2 = document.getElementById('btn2');


      const btn3 = document.getElementById('btn3');


      const btn4 = document.getElementById('btn4');


      const btn5 = document.getElementById('btn5');


      const origen = document.getElementById('origen');


      const variedades = document.getElementById('variedades');


      const disponibilidad = document.getElementById('disponibilidad');


      const propiedades = document.getElementById('propiedades');


      const inf = document.getElementById('info-nut');


      origen.style.display = 'none';
      variedades.style.display = 'none';
      disponibilidad.style.display = 'none';
      propiedades.style.display = 'none';
      inf.style.display = 'none';

      btn1.className = 'btn';
      btn2.className = 'btn';
      btn3.className = 'btn';
      btn4.className = 'btn';
      btn5.className = 'btn';

      if (active == 'origen') {
        console.log('origen');
        btn1.classList.add('active');
        origen.style.display = 'block';
      } else if (active == 'variedades') {
        console.log('var');
        btn2.classList.add('active');
        variedades.style.display = 'block';
      } else if (active == 'dis') {
        console.log('dis');
        btn3.classList.add('active');
        disponibilidad.style.display = 'block';
      } else if (active == 'prop') {
        console.log('props');
        btn4.classList.add('active');
        propiedades.style.display = 'block';
      } else {
        console.log('info');
        btn5.classList.add('active');
        inf.style.display = 'block';
      }
    },
  },
};
</script>

<style lang="scss">
#detalle {

  .active {
    background: gray !important;
    display: block;
  }
  .banner {
      height: 50vh;
      background-image: url('../../assets/images/grid/aguacate.jpg');
      background-position: center;
      background-repeat: no-repeat;
      background-size: cover;
      display: flex;
      justify-content: center;
      align-items: flex-start;

      h2 {
          position: relative;
          top: 10%;
          color: #fff;
          font-size: 2.2em;
          font-weight: bold;
      }
  }
  .flotante {
      position: relative;
      top: -30vh;
      z-index: 10;

  }
  .inf {
      // position: relative;
      // top: -30vh;
      .btns {
          margin: 2% auto;
          margin-bottom: 4%;
          display: flex;
          flex-wrap: wrap !important;
          justify-content: center;
          .btn {
            cursor: pointer;
              width: 200px;
              height: 50px;
              display: flex;
              align-items: center;
              justify-content: center;
              margin: 5px 15px;
              color: #fff;
              background-color: green;
              border-radius: 10px;
              padding: 10px 30px;
          }
          .btn:nth-child(5) {
              width: 300px;
          }
      }
      #bloques {
          text-align: justify;

        > div {
            color: gray;
            font-size: 1.3em;
            margin: 0 20%;
            h2 {
              text-align: center;
            }
        }
        #origen {
          display: block;

          h2 {
            text-align: center;
          }
        }
        #variedades {
            display: none;
        }
        #disponibilidad {
            display: none;
        }
        #propiedades {
            display: none;
        }
        #info-nut {
            display: none;
        }
      }
  }
}

</style>
